import React from 'react';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import { Panel } from 'views/components/molecules/Panel';

const ContentsWrapper = styled.div`
  padding: 0 20px;
`;

type EmailActivationPageLayoutProps = {
  message: string;
};

export const EmailActivationPageLayout: React.FC<EmailActivationPageLayoutProps> = ({
  message,
}) => {
  return (
    <>
      <Spacer />

      <ContentsWrapper>
        <Panel text={message} />
      </ContentsWrapper>
    </>
  );
};
